import { useProfile } from "@/hooks/useProfile";
import { useDaycareHotelSyncSettings } from "@/hooks/useDaycareHotelSyncSettings";

export function useResolvedDaycareHotelClinicId(): { clinicId: string | null; isLoading: boolean } {
  const { data: profile, isLoading: isLoadingProfile } = useProfile();
  const { data: syncSettings, isLoading: isLoadingSync } = useDaycareHotelSyncSettings();
  const currentClinicId = profile?.current_clinic_id ?? null;

  const clinicId =
    syncSettings?.isEnabled && syncSettings.sourceClinicId
      ? syncSettings.sourceClinicId
      : currentClinicId;

  return { clinicId, isLoading: isLoadingProfile || isLoadingSync };
}
